import { createSelector } from 'reselect'

import { selectQbrState } from './selectQbrState'

export const selectQBRDocumentName = createSelector([selectQbrState], (state) => state.name)
